import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useForm, Controller } from 'react-hook-form';
import Select from 'react-select';
import menuPortalProps from 'helpers/reactSelectPortal';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { MdOutlineAssessment } from 'react-icons/md';
import { assignDriverTran, getCarsBySite, getDriversBySite } from 'redux/booking/car/carBookingSlice';
import { Modal, Button } from 'components/common';

const AssignDriverFormSingle = ({ showModal, setshowModal, transaction }) => {
  const { control, formState: { errors }, handleSubmit, setValue } = useForm();
  const [drivers, setDrivers] = useState([]);
  const [carOptions, setCarOptions] = useState([]);
  const [driverOptions, setDriverOptions] = useState([]);
  const dispatch = useDispatch();

  const params = {
    from_date: transaction.from_date,
    to_date: transaction.to_date,
    site_id: transaction.site_id,
  };

  useEffect(() => {
    const fetchCarList = async () => {
      try {
        const response = await dispatch(getCarsBySite(params));
        const data = response.payload;
        setCarOptions((data || []).map((item) => ({ value: item.id, label: item.name })));
      } catch (error) {
        console.error(error);
      }
    };

    const fetchDriverList = async () => {
      try {
        const response = await dispatch(getDriversBySite(params));
        const data = response.payload || [];
        setDrivers(data);
        setDriverOptions(data.map((item) => ({ value: item.id, label: item.name })));
      } catch (error) {
        console.error(error);
      }
    };

    fetchCarList();
    fetchDriverList();
    // load options once on open; `params` is rebuilt every render, so depending on it would refetch on every render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeModal = () => setshowModal(false);

  const handleDriverChange = (value) => {
    setValue('driver_id', value);
    const selectedDriver = drivers.find((driver) => driver.id === value);
    if (selectedDriver) setValue('car_id', selectedDriver.car_id);
  };

  const onSubmit = (data) => {
    try {
      dispatch(assignDriverTran({ transactionId: transaction.id, data }));
      closeModal();
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      title="Assign Driver for car booking"
      footer={(
        <>
          <Button size="sm" variant="secondary" onClick={closeModal}>Cancel</Button>
          <Button size="sm" type="submit" form="assign-driver-single-form" variant="primary" leftIcon={MdOutlineAssessment}>Assign</Button>
        </>
      )}
    >
      <form id="assign-driver-single-form" onSubmit={handleSubmit(onSubmit)}>
        <div className="tw-mb-4">
          <label className="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Driver name</label>
          <Controller
            control={control}
            name="driver_id"
            rules={{ required: 'Driver must be required' }}
            render={({ field }) => (
              <Select
                closeMenuOnSelect
                options={driverOptions}
                placeholder="Select..."
                classNamePrefix="react-select" {...menuPortalProps}
                value={driverOptions.find((option) => option.value === field.value) || null}
                onChange={(selectedOption) => handleDriverChange(selectedOption.value)}
              />
            )}
          />
          {errors.driver_id && <p className="tw-text-xs tw-text-red-600 tw-mt-1 tw-mb-0">{errors.driver_id.message}</p>}
        </div>

        <div>
          <label className="tw-block tw-text-sm tw-font-medium tw-text-slate-700 tw-mb-1.5">Car name</label>
          <Controller
            control={control}
            name="car_id"
            rules={{ required: { value: true, message: 'Car must be required' } }}
            render={({ field }) => (
              <Select
                closeMenuOnSelect
                options={carOptions}
                placeholder="Select..."
                classNamePrefix="react-select" {...menuPortalProps}
                value={carOptions.find((option) => option.value === field.value) || null}
                onChange={(selectedOption) => setValue('car_id', selectedOption.value)}
              />
            )}
          />
          {errors.car_id && <p className="tw-text-xs tw-text-red-600 tw-mt-1 tw-mb-0">{errors.car_id.message}</p>}
        </div>
      </form>
    </Modal>
  );
};

AssignDriverFormSingle.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.func.isRequired,
  transaction: PropTypes.object.isRequired,
};

export default AssignDriverFormSingle;
